<template>
  <div>
    <a-button style="margin-bottom: 10px" type="primary" @click="fetch()">刷新列表 <a-icon type="retweet" /></a-button>
    <div>
      <label title="客户名" class="info">客户名</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="客户名" v-model="biz_name"/>
      <a-button type="primary" @click="setBizInfo()">新增</a-button>
    </div>
    <a-table :columns="columns"
             :dataSource="data"
             :loading="loading"
             :pagination="false"
             class="general-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <div slot="phones" slot-scope="text,record">
        <div class='editable-cell'>
          <div v-if="u_biz_id === record.u_biz_id" class='editable-cell-input-wrapper'>
            <a-input
              placeholder="多个手机号用英文分号（;）隔开"
              v-model="phones"
              ref="input"
              @pressEnter="setBizInfo()"
              style="width: 70%; margin-right: 10px;"></a-input>
            <a-icon
              type='check'
              class='editable-cell-icon-check'
              @click="setBizInfo()"></a-icon>
          </div>
          <div v-else>
            {{text}}
            <a-icon type='edit' class='editable-cell-icon' v-bind:key='record.u_biz_id' @click="editUBizInfo(record)"/>
          </div>
        </div>
      </div>
      <div slot="openids" slot-scope="text,record">
        <div class='editable-cell'>
          <div v-if="u_biz_id === record.u_biz_id" class='editable-cell-input-wrapper'>
            <a-input
              placeholder="多个 openid 用英文分号（;）隔开"
              v-model="openids"
              ref="input"
              @pressEnter="setBizInfo()"
              style="width: 70%; margin-right: 10px;"></a-input>
            <a-icon
              type='check'
              class='editable-cell-icon-check'
              @click="setBizInfo()"></a-icon>
          </div>
          <div v-else>
            {{text}}
            <a-icon type='edit' class='editable-cell-icon' v-bind:key='record.u_biz_id' @click="editUBizInfo(record)"/>
          </div>
        </div>
      </div>
      <div slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a-menu slot="overlay" @click="handleMenuClick($event, record)">
            <!--<a-menu-item v-if="record.vip !== 2" key='start_keep_alive'>开始养号</a-menu-item>-->
            <!--<a-menu-item v-if="record.vip === 2" key='stop_keep_alive'>停止养号</a-menu-item>-->
            <!--<a-menu-item v-if="!record.blocked || record.blocked === 0" key='mark_as_blocked'>标记封号</a-menu-item>-->
            <!--<a-menu-item v-if="record.blocked === 1" key='mark_as_unblocked'>解除封号</a-menu-item>-->
            <a-menu-item key='sms_alarm'>短信通知：机器人异常</a-menu-item>
            <a-menu-item key='app_alarm_disconnect'>公众号推送：机器人异常</a-menu-item>
            <a-menu-item key='app_alarm_block'>公众号推送：机器人封号</a-menu-item>
          </a-menu>
          <a-button>
            操作
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
      </div>
      <!--<div slot="permission_list" slot-scope="text, record">-->
        <!--<a-checkbox-group :options="permissionList" v-model="record.permission_list" @change="onChange(record)" >-->
          <!--&lt;!&ndash;<span style="color: red" slot="label" slot-scope="{value}">{{value}}</span>&ndash;&gt;-->
        <!--</a-checkbox-group>-->
      <!--</div>-->
    </a-table>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'BizManage',
  data () {
    return {
      loading: false,
      biz_name: '',
      phones: '',
      openids: '',
      u_biz_id: '',
      sms_type: 0, // 是否发送短信: 1，发送; 0，不发送;
      app_type: 0, // 是否发送公众号信息: 1，发送; 0，不发送;
      msg_type: 0, // 公众号模板: 1，封号; 0，异常;
      data: [],
      columns: [{
        title: '客户名',
        dataIndex: 'biz_name'
      }, {
        title: '手机号',
        dataIndex: 'phones',
        scopedSlots: {customRender: 'phones'}
      }, {
        title: '微信 openid',
        dataIndex: 'openids',
        scopedSlots: {customRender: 'openids'}
      }, {
        title: '操作',
        dataIndex: 'actions',
        scopedSlots: {customRender: 'actions'}
      }]
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    getBizListUrl: function () {
      return global.DOMAIN + global.API_VERSION + 'ubiz/get_biz_list'
    },
    setBizInfoUrl: function () {
      return global.DOMAIN + global.API_VERSION + 'ubiz/set_biz_info'
    },
    sendMsgToBizUrl: function () {
      return global.DOMAIN + global.API_VERSION + 'ubiz/send_msg_to_biz'
    }
  },
  methods: {
    fetch () {
      this.loading = true
      axios.post(this.getBizListUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            this.data = data.data.content.biz_list
            this.loading = false
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    setBizInfo () {
      axios.post(this.setBizInfoUrl, {
        biz_name: this.biz_name,
        u_biz_id: this.u_biz_id,
        phones: this.phones,
        openids: this.openids,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            if (this.u_biz_id) {
              this.data.forEach(item => {
                if (this.u_biz_id === item.u_biz_id) {
                  Object.assign(item, data.data.content.biz)
                }
              })
            }
            // console.log('dataList', dataList)
            this.u_biz_id = ''
            this.biz_name = ''
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    editUBizInfo (record) {
      this.u_biz_id = record.u_biz_id
      this.biz_name = record.biz_name
      this.phones = record.phones
      this.openids = record.openids
    },
    handleMenuClick (e, record) {
      let action = e.key
      if (action === 'sms_alarm') {
        this.sms_type = 1
        this.sendAlarm(record)
      } else if (action === 'app_alarm_disconnect') {
        this.app_type = 1
        this.msg_type = 0
        this.sendAlarm(record)
      } else if (action === 'app_alarm_block') {
        this.app_type = 1
        this.msg_type = 1
        this.sendAlarm(record)
      }
    },
    sendAlarm (record) {
      axios.post(this.sendMsgToBizUrl, {
        sms_type: this.sms_type,
        app_type: this.app_type,
        msg_type: this.msg_type,
        phones: record.phones,
        open_id: record.openids, // 后端接口是 open_id
        bot_nickname: '小智小智',
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            window.alert('正在发送')
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
